import React from 'react'

const Option3 = () => {
  return (
    <div>Option3</div>
  )
}

export default Option3